"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M14 9h-3V6c0-.55-.45-1-1-1s-1 .45-1 1v3H6c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1z"];
//# sourceMappingURL=small-plus.js.map